module.exports = __webpack_public_path__ + "img/byjswg.b92d566e.svg";